module.exports = __webpack_public_path__ + "static/AmandaP-3a7fd09c31ff540d7134bd2571a9a33d.png";